

    module.exports = require('./DataZoomView').extend({

        type: 'dataZoom.select'

    });




//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/dataZoom/SelectZoomView.js
// module id = 1483
// module chunks = 1